import { render, staticRenderFns } from "./orgs-add-or-update.vue?vue&type=template&id=dfb05536&scoped=true&"
import script from "./orgs-add-or-update.vue?vue&type=script&lang=js&"
export * from "./orgs-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./orgs-add-or-update.vue?vue&type=style&index=0&id=dfb05536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb05536",
  null
  
)

export default component.exports